<ng-container *transloco="let t; prefix: 'fuelConsumption'">
@if (isPageInitialized) {
  <div class="dashboard-top-section d-flex align-items-center justify-content-between">
    <h1>{{ t('title') }}</h1>

    <div class="search-menu-lists d-flex">
      <div class="filters d-flex align-items-center gap-2">
        <app-account-filter [filter]="accountFilter" (filterChanged)="onAccountFilterChange($event)"></app-account-filter>

        <div class="common-drop-down dropdown date-height dropdown-button">
          <app-date-filter [filter]="dateFilter" [isButtonIntervalSelector]="false"
            [disabledIntervals]="disabledIntervals" [defaultInterval]="defaultInterval"
            (filterChanged)="onDateFilterChange($event)">
          </app-date-filter>
        </div>

        <!-- <div class="export-listing">
          <div class="common-drop-down dropdown">
            <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdown-button" data-bs-toggle="dropdown"
              aria-expanded="false">
              {{ 'common.export' | transloco }} <i><img src="./assets/images-fuel/downloadIcon.svg" alt="export-icon" /></i>
            </button>
            <ul class="dropdown-menu" aria-labelledby="dropdown-button">
              <li><a class="dropdown-item">{{ t('export.exportAsPdf') }}</a></li>
              <li><a class="dropdown-item">{{ t('export.exportAsCsv') }}</a></li>
              <li><a class="dropdown-item">{{ t('export.sendViaEmail') }}</a></li>
            </ul>
          </div>
        </div> -->
      </div>
    </div>
  </div>
}

<div class="dashboard-box">
  <div class="row">
    <div class="col-lg-3 col-md-6 col-sm-12">
      <app-fuel-efficiency-widget [dateFilter]="dateFilter"
        [accountFilter]="accountFilter"></app-fuel-efficiency-widget>
    </div>

    <div class="col-lg-3 col-md-6 col-sm-12">
      <app-total-distance-widget [dateFilter]="dateFilter" [accountFilter]="accountFilter"></app-total-distance-widget>
    </div>

    <div class="col-lg-3 col-md-6 col-sm-12">
      <app-total-trips-widget [dateFilter]="dateFilter" [accountFilter]="accountFilter"></app-total-trips-widget>
    </div>

    <div class="col-lg-3 col-md-6 col-sm-12">
      <app-total-fuel-used-widget [dateFilter]="dateFilter"
        [accountFilter]="accountFilter"></app-total-fuel-used-widget>
    </div>
  </div>
</div>

<div class="fuel-consumption-wrapper">
  <div class="fuel-comsump-left">
    <div class="filter-container pb-3 d-flex w-full justify-content-between">
      <div class="w-50">
        <app-search [placeholder]="t('search.placeholder')" [searchTerm]="searchTerm"
          (searchTermUpdated)="onSearchTermChange($event)" [customWidth]="'100%'">
        </app-search>
      </div>

      <div class="d-flex align-items-center gap-2">
        <app-make-model-filter [filter]="makeModelFilter" [accountFilterChanged$]="accountFilterChanged$"
          (filterChanged)="onMakeModelFilterChange($event)">
        </app-make-model-filter>
        <app-driver-filter [filter]="driverFilter" [accountFilterChanged$]="accountFilterChanged$"
          (filterChanged)="onDriverFilterChange($event)"></app-driver-filter>
      </div>
    </div>
    <div class="main-table fuel-consuption-table">
      <table class="table" [class.show-last-border]="showLastRowBorder">
        <thead>
          <tr>
            <th class="assets">{{ t('table.asset') }}</th>
            <th class="driver">{{ t('table.driver') }}</th>
            <th class="distance">{{ t('table.distanceTravelled') }}</th>
            <th class="fuel-used">{{ t('table.fuelUsed') }}</th>
            <th class="efficiency">{{ t('table.efficiency') }}</th>
            <th class="time-stamp">{{ t('table.timeStamp') }}</th>
          </tr>
        </thead>
        @if (isDetailsLoading) {
          <tbody
            class="spinner-container d-flex align-items-center justify-content-center spinner-border">
          </tbody>
        }
        @if (!isDetailsLoading) {
          <tbody>
            @if (!fuelConsumptionDetails.length) {
              <div class="driver-status-table__no-data">
                <span class="table__no-data">
                  <app-empty-state></app-empty-state>
                </span>
              </div>
            }
            @for (row of fuelConsumptionDetails; track $index) {
            <ng-container>
              <tr>
                <td class="assets">{{ row.assetName }}</td>
                <td class="driver"><strong>{{ row.driver }}</strong></td>
                <td class="distance">{{ row.distanceTraveled.toLocaleString() }} km</td>
                <td class="fuel-used">{{ row.fuelUsed.toLocaleString() }} ℓ</td>
                <td class="efficiency">{{ row.efficiency.toLocaleString() }} km/ℓ</td>
                <td class="time-stamp">{{ row.timeStamp | date:'dd/MM/yyyy HH:mm' }}</td>
              </tr>
            </ng-container>
            }
          </tbody>
        }
      </table>
    </div>

    <div class="d-flex align-items-center justify-content-between bottom-options">
      <p class="pagination-text">
        {{ 'common.showingOutOf' | transloco: { current: showingCount, total: totalCount } }}
      </p>

      <app-pagination [totalPages]="totalPages" [currentPage]="page" (pageChange)="goToPage($event)">
      </app-pagination>

      <div class="export-listing" [class.invisible]="true">
        <div class="common-drop-down dropdown">
          <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdown-button" data-bs-toggle="dropdown"
            aria-expanded="false">
            {{ 'common.export' | transloco }} <i><img src="./assets/images-fuel/downloadIcon.svg" alt="export-icon" /></i>
          </button>
          <ul class="dropdown-menu" aria-labelledby="dropdown-button">
            <li><a class="dropdown-item">{{ t('export.exportAsPdf') }}</a></li>
            <li><a class="dropdown-item">{{ t('export.exportAsCsv') }}</a></li>
            <li><a class="dropdown-item">{{ t('export.sendViaEmail') }}</a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <div class="fuel-comsump-right">
    <div class="card-one grap-card increase">
      @if(!isHighConsumptionLoading && !isSummaryLoading && highConsumptionStats.length > 0;){
        <div class="card-body p-0">
          <div class="grap-up d-flex justify-content-between">
            <div class="graph-text">
              <h4>{{ t('highConsumption.title') }}</h4>
              <app-graph-trend-icon [percentageChange]="consumptionPercentageChange"
                [formattedChange]="formatPercentChange()" [formatValue]="formatValue(consumptionTotalValue)"
                [isUptrendPositive]="true">
              </app-graph-trend-icon>
            </div>
            <div class="btn-wrapper">
              <div class="common-drop-down dropdown">
                <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdown-button"
                  data-bs-toggle="dropdown" aria-expanded="false">
                  {{selectedFilter}}<i><img src="./assets/images-fuel/select-arrow-icon.svg" alt="arrow-icon" /></i>
                </button>
                <ul class="dropdown-menu" aria-labelledby="dropdown-button">
                  <li><a class="dropdown-item dropdown-button-font" (click)="getHighConsumptionDrivers()">{{ t('highConsumption.drivers') }}</a></li>
                  <li><a class="dropdown-item dropdown-button-font" (click)="getHighConsumptionAssets()">{{ t('highConsumption.assets') }}</a></li>
                </ul>
              </div>
            </div>
          </div>
          <div class="grap-down pie-chart">
            <app-pie-chart [consumptionStats]="highConsumptionStats" />
          </div>
        </div>
      }
      @else {
        <div class="graph-text">
          <h4>{{ t('highConsumption.title') }}</h4>
        </div>
      }
      @if (isHighConsumptionLoading || isSummaryLoading) {
        <div class="spinner-container d-flex align-items-center justify-content-center spinner-border">
        </div>
      }
      @if (!isHighConsumptionLoading && !isSummaryLoading && highConsumptionStats.length === 0) {
        <div class="table__no-data">
          <app-empty-state></app-empty-state>
        </div>
      }
    </div>
    <div class="card-two dicrease">
      <app-fuel-consumption-widget-graph [widgetExpandable]="false"></app-fuel-consumption-widget-graph>
    </div>
  </div>
</div>
</ng-container>
